import { render, staticRenderFns } from "./FormDesign.vue?vue&type=template&id=6337673a&scoped=true&"
import script from "./FormDesign.vue?vue&type=script&lang=js&"
export * from "./FormDesign.vue?vue&type=script&lang=js&"
import style0 from "./FormDesign.vue?vue&type=style&index=0&id=6337673a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6337673a",
  null
  
)

export default component.exports